import { Box, BoxProps } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { useL10n } from '@uplift/hooks';
import { Form, useFormikContext } from 'formik';
import { InsuranceDropzone, InsuranceDropzoneError } from '../../../Dropzone';
import React, { useMemo } from 'react';
import { Alert } from '../../../Alert';
import { InsuranceFormType } from '../hooks/use-insurance-form.hook';


export type InsuranceCardFormType = {
  isMobile?: boolean;
  dropzoneHeight?: number;
  dropzoneColor?: 'primary' | 'secondary';
} & BoxProps;


export const InsuranceCardForm: React.VFC<InsuranceCardFormType> = ({
  isMobile = false,
  dropzoneHeight = 148,
  dropzoneColor = 'secondary',
  ...boxProps
}) => {
  const l10n = useL10n();
  const { errors } = useFormikContext<InsuranceFormType>();

  const showAlert = useMemo(
    () => [ errors.insuranceCardBack, errors.insuranceCardFront ].some(x => x === InsuranceDropzoneError.FILE_TOO_LARGE),
    [ errors.insuranceCardBack, errors.insuranceCardFront ]
  );

  const { classes } = useStyles({ dropzoneHeight });

  return (
    <Form>
      {showAlert && (
        <Alert className={classes.alert} severity="error">{l10n.accountSettings.insurance.insuranceCardDropRejected}</Alert>
      )}
      <Box display="flex" flexDirection={isMobile ? 'column' : 'initial'} {...boxProps} alignItems={isMobile ? undefined : 'flex-start'} mt={1}>
        <Box display="flex" flexDirection="column" justifyContent="center" gap="8px" flex={1}>
          <InsuranceDropzone
            classes={classes}
            name="insuranceCardFront"
            placeholderText={l10n.accountSettings.insurance.frontSide}
            altText="front side"
            color={dropzoneColor}
          />
        </Box>
        <Box display="flex" flexDirection="column" justifyContent="center" gap="8px" flex={1}>
          <InsuranceDropzone
            classes={classes}
            name="insuranceCardBack"
            placeholderText={l10n.accountSettings.insurance.backSide}
            altText="back side"
            color={dropzoneColor}
          />
        </Box>
      </Box>
    </Form>
  );
};


type StyleProps = Required<Pick<InsuranceCardFormType, 'dropzoneHeight'>>;
const useStyles = makeStyles<StyleProps>({ name: 'InsuranceCardForm' })((theme, { dropzoneHeight }) => ({
  root: {
    height: `${dropzoneHeight}px`,
  },
  empty: {
    height: `${dropzoneHeight}px`,
  },
  preview: {
    height: `${dropzoneHeight}px`
  },
  error: {},
  alert: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2)
  }
}));
